
/**
 * Autelpilot - Mobile Floating Buttons
 * Desktop: unchanged
 * Mobile: fixed Chat and Back to Top positions
 * Buy Me: unchanged
 */

(() => {
  window.autelMobileChat?.destroy?.();
  window.autelFixedButtons?.destroy?.();
  window.autelFloatingPosition?.destroy?.();
  window.autelInboxAvoidance?.disconnect?.();

  const MOBILE_WIDTH = 749;
  const CHAT_BOTTOM = 145;
  const BACK_BOTTOM = 210;
  const STYLE_ID = 'autel-mobile-floating-style';

  let chat = null;
  let originalChatStyle = null;
  let retryTimer = null;
  let attempts = 0;

  document.getElementById(STYLE_ID)?.remove();

  const style = document.createElement('style');
  style.id = STYLE_ID;

style.textContent = `
  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    button.back-to-top {
      position: fixed !important;
      bottom: ${BACK_BOTTOM}px !important;

      width: 50px !important;
      height: 50px !important;
      min-width: 50px !important;
      min-height: 50px !important;

      padding: 0 !important;
      border-radius: 50% !important;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

  document.head.appendChild(style);

  function findChat(root = document) {
    const button = root.querySelector?.(
      '.activator-nudge .activator'
    );

    if (button) {
      return button.closest('.activator-nudge');
    }

    for (const element of root.querySelectorAll?.('*') || []) {
      if (element.shadowRoot) {
        const found = findChat(element.shadowRoot);
        if (found) return found;
      }
    }

    return null;
  }

  function restoreChat() {
    if (!chat) return;

    if (originalChatStyle === null) {
      chat.removeAttribute('style');
    } else {
      chat.setAttribute('style', originalChatStyle);
    }

    chat = null;
    originalChatStyle = null;
  }

  function updateChat() {
    const found = findChat();

    if (!found) return;

    if (chat !== found) {
      restoreChat();
      chat = found;
      originalChatStyle = chat.getAttribute('style');
    }

    if (window.innerWidth <= MOBILE_WIDTH) {
      chat.style.removeProperty('translate');
      chat.style.removeProperty('transform');

chat.style.setProperty(
  'bottom',
  `${CHAT_BOTTOM}px`,
  'important'
);

chat.style.setProperty(
  'right',
  '12px',
  'important'
);
    } else {
      restoreChat();
    }
  }

  function start() {
    updateChat();

    retryTimer = setInterval(() => {
      updateChat();

      if (++attempts >= 60) {
        clearInterval(retryTimer);
        retryTimer = null;
      }
    }, 500);

    window.addEventListener('resize', updateChat);
  }

  window.autelMobileChat = {
    destroy() {
      if (retryTimer) clearInterval(retryTimer);

      window.removeEventListener('resize', updateChat);

      restoreChat();

      document.getElementById(STYLE_ID)?.remove();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();

/**
 * Autelpilot - Desktop Back to Top Position
 * Desktop only.
 * Mobile and Buy Me remain unchanged.
 */

(() => {
  const STYLE_ID = 'autel-desktop-back-to-top';

  document.getElementById(STYLE_ID)?.remove();

  const style = document.createElement('style');
  style.id = STYLE_ID;

  style.textContent = `
    @media screen and (min-width: 750px) {
      button.back-to-top {
        position: fixed !important;
        right: 24px !important;
        bottom: 140px !important;
        z-index: 999 !important;
      }
    }
  `;

  document.head.appendChild(style);
})();
